/**
 * Product Cart - Laoli Theme
 * Handles add to cart functionality
 */

function initPdpCart() {
  const cartCount = document.querySelector('.js-cart-count');
  const forms = document.querySelectorAll('.js-cart-form');

  if (!forms.length) {
    return;
  }

  // Set up add to cart buttons for both selectors
  const addButtons = document.querySelectorAll('.js-add');
  const addButtonsSecondary = document.querySelectorAll('.js-add-secondary');
  const allAddButtons = [...addButtons, ...addButtonsSecondary];
  

  
  allAddButtons.forEach((button, index) => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      

      
      // Get the selected variant ID from the size selector
      const sizeSelectors = document.querySelectorAll('[class*="sizes-wrapper"]');
      let selectedVariantId = null;
      
      // Check if product has multiple variants
      // A product has multiple variants if:
      // 1. There are size selectors visible (not hidden)
      // 2. The wrapper is not hidden (meaning product.variants.size > 1 in Liquid)
      const hasMultipleVariants = sizeSelectors.length > 0 && !sizeSelectors[0].classList.contains('hidden');
      
      // A product has single variant or no variants if:
      // 1. No size selectors found, OR
      // 2. The wrapper is hidden (product.variants.size <= 1 in Liquid)
      const hasSingleOrNoVariants = sizeSelectors.length === 0 || sizeSelectors[0].classList.contains('hidden');
      

      
      if (hasMultipleVariants) {
        // For products with multiple variants, get selected variant
        sizeSelectors.forEach((selector) => {
          const selectedValue = selector.querySelector('[class*="sizes-value"]');
          const menuItems = selector.querySelectorAll('[class*="sizes-menu-item"]');
          
          if (selectedValue && !selectedValue.hasAttribute('data-placeholder')) {
            menuItems.forEach(item => {
              if (item.textContent.trim() === selectedValue.textContent.trim()) {
                selectedVariantId = item.getAttribute('data-id');
              }
            });
          }
        });
        
        // If no variant is selected for multiple variant products, return
        if (!selectedVariantId) {
          return;
        }
      } else {
        // For products with no variants or single variant, use the pre-selected variant
        // The variant is pre-selected by default in Liquid (first_variant.id)
        
        // Get the variant ID from the hidden form input (set by Liquid)
        const formInput = document.querySelector('.js-cart-form input[name="id"]');
        if (formInput) {
          selectedVariantId = formInput.value;
        }
        
        // If still no variant ID, try to get it from the product variants
        if (!selectedVariantId) {
          const menuItems = document.querySelectorAll('[class*="sizes-menu-item"]');
          if (menuItems.length > 0) {
            // Get the first available variant
            selectedVariantId = menuItems[0].getAttribute('data-id');
          }
        }
      }
      
      // If still no variant ID, return
      if (!selectedVariantId) {
        return;
      }
      
      const formData = {
        'items': [{
          'id': selectedVariantId,
          'quantity': 1
        }]
      };



      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(response => {
        if (response.status === 200) {
          // Update cart count
          if (cartCount) {
            let cartCountText = cartCount.textContent;
            if (cartCountText) {
              cartCountText = cartCountText.replace(/\s/g, '');
              cartCountText = cartCountText.replace(/[{()}]/g, '');
              cartCount.textContent = ' (' + (Number(cartCountText) + 1) + ')';
            } else {
              cartCount.textContent = ' (1)';
            }
          }

          // Open cart drawer using existing function
          if (typeof openCart === 'function') {
            openCart();
          } else {
            // Simple solution: click on existing cart button
            const cartButton = document.querySelector('.js-cart-button');
            if (cartButton) {
              cartButton.click();
            }
          }
          

        }
        return response.json();
      }).catch(error => {
        
      });
    });
  });
}

// Export for use in other scripts
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { initPdpCart };
}
